import { cn } from 'noddi-ui-common';
import { calendarStatusChipVariants, calendarStatusDotVariants } from './calendarEntryVariants';
import { CalendarStatusLegendItem } from './types';

interface Props {
  /** Only the statuses this calendar can actually paint, in the order its cells stack them. */
  items: CalendarStatusLegendItem[];
  className?: string;
}

/** The color key for a month calendar — the same circle labels on every page that shows one. */
export const CalendarStatusLegend = ({ items, className }: Props) => (
  <div className={cn('flex flex-wrap items-center gap-2', className)}>
    {items.map(({ status, label }) => (
      <span key={status} className={calendarStatusChipVariants({ status })}>
        <span aria-hidden className={calendarStatusDotVariants({ status })} />
        {label}
      </span>
    ))}
  </div>
);
